import { useQuery } from '@tanstack/react-query';
import { request } from '@core/api/request';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

export const getCustomerPortal = async (): Promise<{ url: string }> => {
  return request({
    url: 'subscriptions/stripe-customer-portal/',
  });
};

export const useGetCustomerPortal = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.getEWallet],
    queryFn: async () => await getCustomerPortal(),
  });
};
